/**
 * Takes a origin URL and removes the URL protocol and suffixed port (if included).
 */
export const formatHostname = (url: string) =>
  url.replace(/^https?:\/\//, '').replace(/:([0-9]*)/g, '');
